import { ReactComponent as WhatsAppOutlineSvg } from "./svg/whatsapp-outline.svg";

export const IconWhatsAppOutline = () => <WhatsAppOutlineSvg />;
